import { connect } from 'react-redux'

import {
  changeTab,
  getInvoices,
  updateQs,
  openFilter,
  setStartDate,
  setEndDate,
  setSearchBy,
  setSearchKeyWords,
} from 'reduxpath/ducks/ZotapayInvoices/List'

import { getProjects, setprojectStatusList } from 'reduxpath/ducks/Project/List'

import { setSelectedProjectStatus } from 'reduxpath/ducks/Reference'

import List from './units'

const mapStateToProps = state => ({
  tab: state.ZotapayInvoices.tab,
  isLoading: state.ZotapayInvoices.isLoading,
  qs: state.ZotapayInvoices.qs,
})
const mapDispatchToProps = dispatch => ({
  handleChangeTab(value, qs) {
    // -- For set query for status that depends on selected tab -- //
    const checkValue = (valueParam) => {
      if (valueParam > 0) {
        return valueParam
      }
      return {
        '>': 0,
      }
    }
    const newQs = {
      ...qs,
      skip: 0,
      where: {
        status: checkValue(value),
      },
    }

    dispatch(openFilter(false))
    dispatch(changeTab(value))
    dispatch(getInvoices(newQs))
    dispatch(updateQs(newQs))

    // -- Reset state startDate, endDate, searchBy, searchKeyWords to default value -- //
    dispatch(setStartDate(null))
    dispatch(setEndDate(null))
    dispatch(setSearchBy('invoiceNumber'))
    dispatch(setSearchKeyWords(''))
  },
  handleDirectToPaymentNeeded() {
    const qs = {
      sort: 'createdAt DESC',
      skip: 0,
      limit: 10,
      where: {
        status: 8,
      },
    }
    dispatch(getProjects(qs))
    dispatch(setSelectedProjectStatus('8'))
    dispatch(setprojectStatusList('8'))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List)
